module.exports = __webpack_public_path__ + "static/media/02-lambda-feedback.061cf40c.jpg";